import * as bootstrap from 'bootstrap'
window.addEventListener('load', function () {
    let wpfiles = document.querySelectorAll('.wpfile-modal-opener')

    const wpfileModal = document.getElementById('wpfile-modal')
    const wpcf7Form = wpfileModal.querySelector('.wpcf7')

    const bsModal = new bootstrap.Modal(wpfileModal, {
        backdrop: 'static',
        focus: true,
        keyboard: true,
    })

    let key = ''

    wpfiles.forEach((wpfile) => {
        wpfile.addEventListener('click', (event) => {
            event.preventDefault()

            // Get saved data from sessionStorage

            key = event.target.dataset.key

            // If has already download, not form
            let has_already_download = sessionStorage.getItem('has_already_download')
            if (has_already_download) {
                console.log('YOP')
                getFileUrl()
                return
            }

            // Show modal / Form
            bsModal.show()
            wpcf7Form.querySelector('input[name="key"]').value = key
            wpcf7Form.querySelector('input[name="url"]').value = document.location.href
            wpcf7Form.addEventListener('wpcf7mailsent', getFileUrl, false)
        })
    })

    let getFileUrl = () => {
        // download file
        fetch(home_url + '/wp-json/imie/download/', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ key: `${key}` }),
        })
            .then(function (response) {
                return response.json()
            })
            .then(function (url) {
                // Save data to sessionStorage
                sessionStorage.setItem('has_already_download', true)

                // Download file
                var link = document.createElement('a')
                link.href = url
                link.download = url.substr(url.lastIndexOf('/') + 1)
                link.click()
            })
            .catch(function (error) {
                console.log(error)
            })

        // Hide modal
        wpcf7Form.querySelector('input[name="key"]').value = ''
        wpcf7Form.querySelector('input[name="url"]').value = ''
        wpcf7Form.removeEventListener('wpcf7mailsent', getFileUrl, true)
        bsModal.hide()
    }
})
